/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */

export type FleetMembershipStatusEnum = typeof FleetMembershipStatusEnum[keyof typeof FleetMembershipStatusEnum];


export const FleetMembershipStatusEnum = {
  CREATED: 'created',
  INVITED: 'invited',
  REQUESTED: 'requested',
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
} as const;
